class DownloadTrackerCorrectionUpdateModel {
  constructor(id, type, correction) {
    this.id = id;
    this.type = type;
    this.correction = correction;
  }
}

export default DownloadTrackerCorrectionUpdateModel;
